import { supabase } from "../lib/supabase";

export const authService = {
  // Sign up new user
  async signUp(email, password, userData = {}) {
    const { data, error } = await supabase?.auth?.signUp({
      email,
      password,
      options: {
        data: {
          full_name: userData?.full_name || '',
          role: userData?.role || 'publisher',
          company_name: userData?.company_name || ''
        }
      }
    });

    if (error) throw error;
    return data;
  },

  // Sign in user
  async signIn(email, password) {
    const { data, error } = await supabase?.auth?.signInWithPassword({
      email,
      password
    });

    if (error) throw error;
    return data;
  },

  // Sign out user
  async signOut() {
    const { error } = await supabase?.auth?.signOut();
    if (error) throw error;
  },

  // Get current session
  async getSession() {
    const { data: { session }, error } = await supabase?.auth?.getSession();
    if (error) throw error;
    return session;
  },

  // Get current user profile
  async getUserProfile(userId) {
    const { data, error } = await supabase?.from('user_profiles')?.select(`
        *,
        publisher_profiles(*),
        buyer_profiles(*)
      `)?.eq('id', userId)?.single();

    if (error && error?.code !== 'PGRST116') throw error;
    return data;
  },

  // Update user profile
  async updateUserProfile(userId, updates) {
    const { data, error } = await supabase?.from('user_profiles')?.update({
        ...updates,
        updated_at: new Date()?.toISOString()
      })?.eq('id', userId)?.select()?.single();

    if (error) throw error;
    return data;
  },

  // Create or update publisher profile
  async updatePublisherProfile(userId, profileData) {
    const { data, error } = await supabase?.from('publisher_profiles')?.upsert({
        user_id: userId,
        ...profileData
      })?.select()?.single();

    if (error) throw error;
    return data;
  },

  // Create or update buyer profile
  async updateBuyerProfile(userId, profileData) {
    const { data, error } = await supabase?.from('buyer_profiles')?.upsert({
        user_id: userId,
        ...profileData
      })?.select()?.single();

    if (error) throw error;
    return data;
  },

  // Reset password
  async resetPassword(email) {
    const { data, error } = await supabase?.auth?.resetPasswordForEmail(email, {
      redirectTo: `${window.location?.origin}/reset-password`
    });

    if (error) throw error;
    return data;
  },

  // Update password
  async updatePassword(newPassword) {
    const { data, error } = await supabase?.auth?.updateUser({
      password: newPassword
    });

    if (error) throw error;
    return data;
  },

  // Check if user exists by email
  async checkUserExists(email) {
    const { data, error } = await supabase?.from('user_profiles')?.select('id, email')?.eq('email', email)?.single();

    if (error && error?.code !== 'PGRST116') throw error;
    return !!data;
  },

  // Get user by role
  async getUsersByRole(role) {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('role', role)?.eq('is_active', true)?.order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  }
};